import React from 'react';

function Standard3(){
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" id="standard" viewBox="0 0 124.6 122" >
            <g id="standard3">
                <circle className="st8" cx="62" cy="30.9" r="20.3"/>
                <circle className="st8" cx="25.6" cy="45.1" r="15.7"/>
                <circle className="st8" cx="97.8" cy="44.7" r="15.7"/>
                <path className="st8" d="M86.8,110.3H35.8c-1.2,0-2.1-0.9-2.1-2.1V68.1c0-6.7,5.4-12.1,12.1-12.1h30.9c6.7,0,12.1,5.4,12.1,12.1v40.1
                    C88.8,109.4,87.9,110.3,86.8,110.3z"/>
                <path className="st8" d="M26.4,110.9H10.7c-4.4,0-8-3.6-8-8v-23c0-8.3,6.8-15,15-15h8.7V110.9z"/>
                <path className="st8" d="M97.2,110.5h15.7c4.4,0,8-3.6,8-8v-23c0-8.3-6.8-15-15-15h-8.7V110.5z"/>
            </g>
        </svg>
    )
}

export default Standard3;